module.exports = __webpack_public_path__ + "img/by.2e0c62f6.svg";